/* Aura Austral — JS propio. Vanilla, sin librerias. Cada init comprueba que su
   elemento existe, asi el mismo archivo sirve para todas las paginas. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveal al hacer scroll — a prueba de fallos: el contenido NUNCA
     se queda oculto aunque IntersectionObserver no dispare ---- */
  function initReveals() {
    var els = document.querySelectorAll('.aa-reveal:not(.aa-visible)');
    if (!els.length) return;

    function show(el) { el.classList.add('aa-visible'); }

    if (reduceMotion) {
      els.forEach(show);
      return;
    }

    var list = Array.prototype.slice.call(els);

    function checkAll() {
      var vh = window.innerHeight || document.documentElement.clientHeight || 800;
      list = list.filter(function (el) {
        if (el.getBoundingClientRect().top < vh * 1.15) { show(el); return false; }
        return true;
      });
      if (!list.length) {
        window.removeEventListener('scroll', checkAll);
        window.removeEventListener('resize', checkAll);
      }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { show(entry.target); io.unobserve(entry.target); }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });
      list.forEach(function (el) { io.observe(el); });
    }

    checkAll();
    window.addEventListener('scroll', checkAll, { passive: true });
    window.addEventListener('resize', checkAll);
    // Failsafe: pase lo que pase, a los 2.5 s todo queda visible.
    setTimeout(function () { document.querySelectorAll('.aa-reveal').forEach(show); }, 2500);
  }

  /* ---- Marquesina: duplica el contenido y fija la duracion ---- */
  function initMarquees() {
    document.querySelectorAll('.aa-marquee__track').forEach(function (track) {
      if (track.dataset.aaReady) return;
      track.dataset.aaReady = '1';
      var speed = parseFloat(track.dataset.speed || '30');
      track.innerHTML += track.innerHTML;
      track.style.animationDuration = speed + 's';
    });
  }

  /* ---- Galeria de la pagina de producto ---- */
  function initPdpGallery() {
    var gallery = document.querySelector('[data-aa-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-aa-gallery-main] img');
    var thumbs = gallery.querySelectorAll('[data-aa-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var full = btn.getAttribute('data-full');
        if (full) main.src = full;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }

  /* ---- Selector de variantes de la pagina de producto ---- */
  function initPdpVariants() {
    var form = document.querySelector('[data-aa-product-form]');
    if (!form) return;
    var dataEl = document.querySelector('[data-aa-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector('[data-aa-add]');
    var priceEl = document.querySelector('[data-aa-price]');
    var addLabel = addBtn ? addBtn.getAttribute('data-label-add') : 'Agregar';
    var soldLabel = addBtn ? addBtn.getAttribute('data-label-sold') : 'Agotado';

    function selectedOptions() {
      var groups = form.querySelectorAll('[data-aa-option-index]');
      var values = [];
      groups.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-aa-option-index'), 10);
        var checked = group.querySelector('input:checked');
        if (checked) values[idx] = checked.value;
      });
      return values;
    }

    function money(cents) {
      try {
        return new Intl.NumberFormat('es-CL', {
          style: 'currency', currency: dataEl.getAttribute('data-currency') || 'CLP',
          maximumFractionDigits: 0
        }).format(cents / 100);
      } catch (e) { return '$' + (cents / 100); }
    }

    function update() {
      var chosen = selectedOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) {
        var html = '';
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += '<s>' + money(match.compare_at_price) + '</s>';
        }
        html += money(match.price);
        priceEl.innerHTML = html;
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addLabel : soldLabel;
      }
    }

    form.querySelectorAll('[data-aa-option-index]').forEach(function (group) {
      group.querySelectorAll('input').forEach(function (input) {
        input.addEventListener('change', function () {
          var cur = group.querySelector('[data-aa-option-current]');
          if (cur) cur.textContent = input.value;
          update();
        });
      });
    });
    update();
  }

  /* ---- Añadir al carrito (sin depender de los componentes de Dawn) ---- */
  function initPdpAddToCart() {
    var form = document.querySelector('[data-aa-product-form]');
    if (!form) return;
    var btn = form.querySelector('[data-aa-add]');
    var err = document.querySelector('[data-aa-error]');
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn && btn.disabled) return;
      var labelAdd = btn ? btn.getAttribute('data-label-add') : 'Agregar';
      if (err) { err.hidden = true; err.textContent = ''; }
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); btn.textContent = 'Agregando…'; }

      var fd = new FormData(form);
      var body = {};
      fd.forEach(function (v, k) { if (k === 'id' || k === 'quantity') body[k] = v; });
      if (!body.quantity) body.quantity = 1;

      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            if (err) { err.hidden = false; err.textContent = res.j.description || res.j.message || 'No se pudo agregar. Prueba otra opción.'; }
            if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); btn.textContent = labelAdd; }
            return;
          }
          if (btn) { btn.textContent = '✓ Agregado'; }
          window.location.href = cartUrl;
        })
        .catch(function () { window.location.href = cartUrl; });
    });
  }

  function boot() {
    initReveals();
    initMarquees();
    initPdpGallery();
    initPdpVariants();
    initPdpAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // Re-inicializa en el editor de Shopify al recargar una seccion
  document.addEventListener('shopify:section:load', boot);
})();
